import { render, staticRenderFns } from "./ReceiptDetails.vue?vue&type=template&id=0089d171"
import script from "./ReceiptDetails.vue?vue&type=script&lang=js"
export * from "./ReceiptDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports